<template>

  <div class="homescreenmk">
    <div id="speed-settings" class="settings hide">
      <div class="maxwidth">
        <h1><span class="show-en">Before you begin, choose your experience</span><span class="show-fr">Avant de commencer, choisissez votre expérience</span></h1>
        <h2><span class="show-en">Standard</span><span class="show-fr">Standard</span></h2>
        <p><span class="show-en">Standard version – choose this version if you want extra time and a more controlled click-through experience. Ideal for screen readers.</span><span class="show-fr">Version standard – choisissez cette option si vous souhaitez plus de temps et une navigation plus contrôlée. Idéal pour les lecteurs d'écran.</span></p>
        <div>
          <button class="btn2"  @click="playWithAutoplayFN(false)"><span class="show-en">Standard</span><span class="show-fr"> Standard</span></button>
        </div>
        <h2><span class="show-en">Fast Track</span><span class="show-fr">Rapide</span></h2>
        <p><span class="show-en">Fast track version – choose this version if you want a faster experience that includes more automatic playing of sequences. Not ideal for screen readers.</span><span class="show-fr">Version rapide – choisissez cette option pour une expérience plus rapide avec une lecture automatique accrue des séquences. Non recommandé pour les lecteurs d'écran.</span></p>
        <div>
          <button class="btn2"  @click="playWithAutoplayFN(true)"><span class="show-en">Fast Track</span><span class="show-fr">Rapide</span></button>
        </div>
      </div>
    </div>
    <div class="home">
      <div>
        <div class="bgimg-wrapper">
          <div id="title">
            <img src="img/hh_title.png" class="fullimg bgimg show-en" alt="Healthy Heroes"/>
            <img src="img/hh_title-fr.png" class="fullimg bgimg show-fr" alt="Les Super héros de la santé"/>
          </div>
          <div id="heroes"><img src="img/hh_heroes.png" class="fullimg bgimg" alt="Alex, Madi and Vik"/></div>
          <div v-if="language='E'" id="drd">
            <img src="img/hh_drd.png" class="fullimg bgimg show-en" alt="In a daze of disarray"/>
            <img src="img/hh_drd-fr.png" class="fullimg bgimg show-fr" alt="Malheur et confusion"/>
          </div>
        </div>
        <div class="btns-wrapper">
          <!-- <button id="btn-play" class="btn btn-play"><span class="balancer" @click="showSpeedSettingsFN"></span>Play <img src="img/chevron.svg"></button> -->
          <button class="btn btn-play" @click="showSpeedSettingsFN"><span class="balancer"></span><span class="show-en">Play</span><span class="show-fr">Jouer</span> <img src="img/chevron.svg"></button>
          <button class="btn2 btn-instructions"><span class="balancer"></span><span class="show-en">Instructions</span><span class="show-fr">Instructions</span> <img src="img/question-mark.svg" class="invisible"></button>
          <button class="btn2 btn-chapters"><span class="balancer"></span><span class="show-en">Chapters</span><span class="show-fr">Chapitres</span> <img src="img/question-mark.svg" class="invisible"></button>
          <!-- <a href="game/scan-game-alex-1/">Scan Alex 1</a>
          <a href="game/scan-game-alex-2/">Scan Alex 2</a>
          <a href="game/scan-game-madi-1/">Scan Madi</a>
          <a href="game/scan-game-vik-1/">Scan Vik</a>
          <a href="game/wire-game/">Wire Game</a>
          <a href="game/wire-game-mobile/">Wire Game Mobile</a> -->
          <!-- <button class="btn2 btn-instructions"><span class="balancer"></span>Instructions <img src="img/question-mark.svg"></button> -->
          <!-- <button class="btn2 btn-chapters"><span class="balancer"></span>Chapters <img src="img/question-mark.svg"></button> -->
        </div>
        <div class="btn-gear-wrapper"><button id="gear" class="btn-gear btn-gear-home"><img src="img/gear.svg" alt="Gear"></button></div>
      </div>
    </div>
    <!-- <div class="instructions" v-if="instOpen">
      <button class="btn" @click="toggleInstructions"><img src="img/chevron.svg" class="mirror-img">Back<span class="balancer"></span></button>
      <div>
        <button class="btn2 center">Settings</button>
        <button class="btn2 center px-1">Instructions</button>
        <button class="btn2 center transparent">Chapters</button>
      </div>
      <div class="select-wrapper">
        <select class="select-settings" name="" id="">
          <option value="">Settings</option>
          <option value="">Instructions</option>
          <option value="">Chapters</option>
        </select>
      </div>
      <div class="hide">
        <h1>Instructions</h1>
        <h2>Navigational Instructions</h2>
        <p>Press “Play” to start this interactive comic book. Use the “Next” button to advance to the next panel in the story. If you need to go back and reread speech bubbles within a panel, press “Back”. NOTE: This will only go as far back to the beginning of the panel and no further.</p>
        <h2>How to Make Decisions</h2>
        <p>When you come to a decision point, you will have two options on how to move forward in the story. Click on the option you prefer.</p>
        <h2>Mini Games</h2>
        <p>This interactive comic book features games that bring you into the action. You will find instructions on how to play before each game. You can also choose to skip any game.</p>
        <h2>Settings and Accesibility Panel</h2>
        <p>To access the Settings and Accessibility Panel, click on the gear icon <img class="icon" src="img/gear.svg">. You will find it on the bottom left of the opening page and on every decision point page. Click on it to do things like mute audio and adjust text size.</p>
      </div>
      <div>
        <h1>Chapters</h1>
        <ul class="chapters-list">
          <li><a href="?hh=1" data-page="1" data-scene="1">Hanging out at the hideout</a></li>
          <li><a href="http://www.google.com" data-page="6" data-scene="1">Dr. Disarray raises alarm</a></li>
          <li><a href="#" data-page="10" data-scene="1">Heroes start hero-ing</a></li>
          <li><a href="#" data-page="13" data-scene="1">Situation critical</a></li>
          <li><a href="./game/wire-game" data-page="15" data-scene="1">Alex tree swings: Mini-game</a></li>
          <li><a href="#" data-page="24" data-scene="4">Madi rewires robot: Mini-game</a></li>
          <li><a href="#" data-page="32" data-scene="1">Vik and Madi team up</a></li>
          <li><a href="#" data-page="32" data-scene="6">Vik dodges robots: Mini-game</a></li>
          <li><a href="#" data-page="34" data-scene="1">Heroes face Dr. Disarray</a></li>
          <li><a href="#" data-page="39" data-scene="1">Vik to the rescue</a></li>
          <li><a href="#" data-page="43" data-scene="1">The next day</a></li>
        </ul>
      </div>
    </div> -->
    <!-- <div id="settings-parent" ></div> -->
  </div>
</template>

<script>


export default {
  name: 'HomeScreen',
  // props: {
  //   appData: {
  //       type: Object
  //   }
  // },
  data() {
      return {
        language: 'E',
        appData: {},
        desktopView: false,
        desktopOffset: 2,
        instOpen: false
      }
    },
    beforeMount() {
    },
    mounted() {

      var that = this;

      var tl = gsap.timeline();
			tl.fromTo('#title', .7, {alpha:0},{alpha:1});
			tl.fromTo('#heroes', .7, {alpha:0,y:10},{alpha:1,y:0});
      tl.fromTo('#drd', .7, {alpha:0,y:10},{alpha:1,y:0},'-=.2');
      tl.fromTo('#gear', .7, {alpha:0},{alpha:1},'-=.3');
      tl.fromTo('.btn-play', .7, {alpha:0,y:5},{alpha:1,y:0});
      tl.fromTo('.btn-instructions', .7, {alpha:0,y:5},{alpha:1,y:0},'-=.5');
      tl.fromTo('.btn-chapters', .7, {alpha:0,y:5},{alpha:1,y:0},'-=.3');
      let sessLang = sessionStorage.getItem("lang");
      //console.log(sessLang)
      if (sessionStorage.getItem("lang") == 'F') {
        setTimeout(()=> {
          document.documentElement.lang = 'fr-ca'
        },2000)


      } else {
        setTimeout(()=> {
          document.documentElement.lang = 'en-ca'
        },2000)

      }

      setTimeout(()=> {
        window.parent.preloadAudio();
      },2200)

    },
    methods: {
      startFN: function(){
        this.$parent.hideHomeFN();
      },
      showSpeedSettingsFN: function() {
        document.getElementById('speed-settings').classList.remove('hide');
        window.parent.playSound('heroTheme');
        window.parent.loadSirenSFX();
      },
      playWithAutoplayFN: function(s) {
        //console.log('s', s)
        parent.setAutoplay(s);
        // startFN();
        this.$parent.hideHomeFN();
        if(s == true){
          parent.setAutoplay(s);
        }
      },
      toggleInstructions: function(){
        // if(this.instOpen == false){
        //   this.instOpen = true
        //   return
        // }
        // this.instOpen = false
        document.querySelector('.btn-gear').click();
      }
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
.invisible {
  visibility: hidden;
}
// .fullimg{
//   width:100%;
//   height: 100%;
// }

// #drd img, #heroes img {
//   position: absolute;
// }

// #title{
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 10;
// }

// #heroes{
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 11;
// }

// #drd{
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 12;
// }

// #gear{
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 13;
// }

.icon {
  vertical-align: middle;
  width: 1rem;
}

#drd, #heroes {
  position: absolute;
  top: 0;
}
// @media only screen and (max-width: 799px) {
//   #drd, #heroes {
//     height: 100%;
//     display: flex;
//     align-items: center;
//   }

// }

body.mobile #drd, body.mobile #heroes {
  height: 100%;
  display: flex;
  align-items: center;
}

.headsupdisplay {
  opacity: 0;
}
.hud {
  margin-top:25%;

  @media only screen and (max-width: 600px) {
    margin-top: 0%;
  }
}

hud-content{
  position: relative;
}

// button {
//   font-family: "Outfit", sans-serif;
//   border-radius: 30px;
//   padding: .6rem 3rem;
//   color: white;
//   background: #68277E;
//   border: 3px solid black;
//   box-shadow: 3px 3px 14px 1px rgba(0, 0, 0, 0.4);
// }

// button:hover {
//   background: white;
//   color: #68277E;
// }

.nextBT{
  font-size: 1.25rem;
  font-weight: 700;
  display: block;
  margin-top: 10px;
  float: right;
}


// .btn {
//   display: inline-block;
//   width: auto;
//   color: white;
//   font-size: 28px;
//   font-size: 18.6666666667px;
//   background: #68277E;
//   border: 2px solid #060707;
//   border-radius: 50px;
//   line-height: 1;
//   padding: 16px;
//   padding: 10.6666666667px;
//   font-weight: bold;
//   padding-left: 50px;
//   padding-left: 33.3333333333px;
//   /* margin-top: 59.7777777778%; */
//   position: absolute;
//   top: 59%;
//   left: 50%;
//   transform: translateX(-50%);

//   min-width: 230px;
//   /* transform: translate(60) */
// }
// .btn span {
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   width: 40px;
//   height: 40px;
//   width: 26.6666666667px;
//   height: 26.6666666667px;
//   background: white;
//   color: #F6790B;
//   border-radius: 50%;
//   margin-left: 34px;
//   margin-left: 22.6666666667px;
// }
// .btn:hover {
//     background-color: white;
//     color: #68277E;
//     border-color: #68277E;
// }

.btn, .btn2 {
  cursor: pointer;
  display: inline-block;
	width: auto;
	color: white;
	font-size: 18.7px;
  font-size: 1.16875rem;
	background: #68277E;
	border: 2px solid #060707;
	border-radius: 33.3px;
  border-radius: 2.08125rem;
	line-height: 1;
	padding: 4.5px 10.7px;
  padding: 0.28125rem 0.66875rem;
	font-weight: bold;
	/* padding-left: 33.3px; */
	display: inline-flex;
	align-items: center;
	gap: 16px;
  gap: 1rem;
	// min-width: 172px;
  // min-width: 10.75rem;
	width: 210px;
  width: 13.125rem;
	/* justify-content: flex-end; */
	justify-content: space-between;
	margin-top: 8px;
  line-height: 26.7px;
  line-height: 1.66875rem;
}

.btn2 {
  background-color: white;
  color: #68277E;
  margin-top: 0.5625rem;
}

.btn2.center {
  justify-content: center;
  margin-bottom: 0.5rem;
}

.btn2:hover {
  color: white;
	background-color: #68277E;
}

.btn2.transparent {
  background: transparent;
  border-color: #C0A8AE;
}

.btn2.transparent:hover {
  background-color: transparent;
  color: #68277E;
}

.px-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.btn img, .btn2 img {
  display: inline-block;
  width: 26.7px;
  height: 26.7px;
  width: 1.66875rem;
  height: 1.66875rem;
	flex-grow: 0;
}

.btn-gear {
  position: absolute;
  bottom: calc(50% + 10px + 0.625rem);
  left: calc(10px + 0.875rem);
  background: transparent;
  padding: 0;
  border: 0;
  width: 2.5rem;
  // width: 1.875rem;
  width: 2.25rem;
  cursor: pointer;
  z-index: 101;
}
.btn-gear img {
  width: 100%;
  vertical-align: bottom;
}

.btn-gear:hover {
  transform: scale(1.1);
}

.btn .balancer, .btn2 .balancer {
  width: 26.7px;
  width: 1.66875rem;
	flex-grow: 0;
}

.btns-wrapper {
  position: absolute;
  flex-direction: column;
  display: flex;
  right: 5%;
  top: 16.5%;
  z-index: 100;
}

.mirror-img {
  transform: scaleX(-1);
}
.bgimg{
  width:100%;
  height: 100%;
}

.instructions, .instructions * {
  box-sizing: border-box;
}
.instructions {
  // font-family: "Outfit", sans-serif;
  // padding: 60px 0;
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;
  // background: white;
  // z-index: 100;
  font-family: "Outfit", sans-serif;
  position: absolute;
  background: #FFFBD3;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  aspect-ratio: 8 / 6;
  // padding: 2rem;
  padding: 2rem;
  // padding-bottom: 4rem;
  font-size: 1rem;
  z-index: 102;
}

.insttext {
  margin: 0 auto;
  width: 75%;
  margin-bottom: 40px;
}


// @media only screen and (max-width: 799px) {
//   .btns-wrapper {
//     position: relative;
//     align-items: center;
//     right: auto;
//     top: auto;
//   }
//   .home {
//     height: 100%;
//   }
//   .home > div {
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: space-between;
//     align-items: center;
//   }
//   .bgimg-wrapper {
//     flex-grow: 2;
//     display: flex;
//     align-items: center;
//     position: relative;
//   }
//   .bgimg {
//     width: auto;
//     height: auto;
//     max-width: 100%;
//   }
//   .btns-wrapper {
//     flex-grow: 1;
//     padding-bottom: 20px;
//   }
//   .btn-gear-wrapper {
//     display: flex;
//     justify-content: flex-start;
//     width: 100%;
//   }
//   .btn-gear{
//     margin-bottom: 15px;
//     margin-left: 15px;
//     width: 2.5rem;
//     height: 2.5rem;
//     position: relative;
//     left: auto;
//     bottom: auto;
//   }
//   .btn-gear img {
//     width: 100%;
//   }
//   .instructions {
//     aspect-ratio: auto;
//     bottom: 0;
//   }
// }

body.mobile .btns-wrapper {
  position: relative;
  align-items: center;
  right: auto;
  top: auto;
}
body.mobile .home {
  height: 100%;
}
body.mobile .home > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
body.mobile .bgimg-wrapper {
  flex-grow: 2;
  display: flex;
  align-items: center;
  position: relative;
}
body.mobile .bgimg {
  width: auto;
  height: auto;
  max-width: 100%;
}
body.mobile .btns-wrapper {
  flex-grow: 1;
  padding-bottom: 20px;
}
body.mobile .btn-gear-wrapper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
body.mobile .btn-gear {
  margin-bottom: 15px;
  margin-left: 15px;
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  left: auto;
  bottom: auto;
}
body.mobile .btn-gear img {
  width: 100%;
}
body.mobile .instructions {
  aspect-ratio: auto;
  bottom: 0;
}


.instructions h1 {
  font-size: 1.5rem;
  margin: 2rem 0 1.5rem 0;
}
.instructions h2 {
  font-size: 1.2rem;
  margin: 0;
}
.instructions p {
  font-size: 1rem;
  margin: 1rem 0 2rem 0;
}
// .instructions::-webkit-scrollbar {
//     width: 10px;
// }

// .instructions::-webkit-scrollbar-track {
//     background-color: #e7e7e7;
//     border: 1px solid #cacaca;
// }

// .instructions::-webkit-scrollbar-thumb {
//     background-color: #68277E;
//     // background-color: #f2b243;
// }
.instructions::-webkit-scrollbar {
    width: 17px;
}

.instructions::-webkit-scrollbar-track {
    // border-radius: 8px;
    background-color: #e7e7e7;
    border: 1px solid #cacaca;
}

.instructions::-webkit-scrollbar-thumb {
    // border-radius: 8px;
    background-color: #e68033;
}


</style>

